import { LanguageService } from "./language.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Subject } from "rxjs/Subject";
import { Injectable, EventEmitter } from "@angular/core";
import { Ace } from "app/lib/ace-builds/src-noconflict/ace";

// #########################################################################
//
// This service is used to keep track of all information about the previous
// commands. We keep track of the following thing and provide an interface to access
// those information from a component:
//      - commands
//      - current command index
//
// We can add arbitrary Strings to the commands array and it will be automatically
// appended to the historyComponent because they are bound together
//
// #########################################################################

declare var ace: any;

@Injectable()
export class CommandsService {
  public ctEmitter: EventEmitter<void> = new EventEmitter<void>();
  public inputChangedEmitter: EventEmitter<void> = new EventEmitter<void>();
  public commands = [{}];
  private historyCommandsOnly: string[] = [""];
  private currentCommandIndex: number = -1;
  public space: Subject<Object[]> = new BehaviorSubject<Object[]>(null);
  private lang: LanguageService;

  public inputLine: any;

  private errorCol = "#ff8000";
  private commandCol = "black";
  constructor() {
    console.log("CommandsService constructed");
  }
  // TODO: pretty ugly hack. How can the language service be passed down here?
  public setLangService(lang) {
    this.lang = lang;
    console.log(lang);
    this.lang.space.subscribe(val => {
      if (val != undefined) {
        //this.checkPlaceholderText();
      }
    });
  }

  public emitInputChangeEvent() {
    this.inputChangedEmitter.emit();
  }

  public setInputLine(inputLine: any) {
    this.inputLine = inputLine;
  }

  public setCommandLineText(text) {
    this.inputLine.setValue(text);
    const col = this.inputLine.session.getLine(0).length;
    this.inputLine.selection.moveTo(0, col);
  }
  public getCommandLineText() {
    return this.inputLine.getValue();
  }
  public addString(text: string) {
    this.commands.push({ text: text, color: this.errorCol });
    this.space.next(this.commands);
  }
  public addCommand(text: string) {
    this.commands.push({ text: text, color: this.commandCol });
    this.historyCommandsOnly.push(text);
    this.space.next(this.commands);
  }
  public addErrorMessage(errormessages: string[], input: string) {
    let headlineChar = "~";
    let startErrorlineChars = "~ ";
    let headlineChars;
    let headlineLength;
    //find maximum size among all error messages
    let maxSize = 0;
    for (
      var errorMessageIndex = 0;
      errorMessageIndex < errormessages.length;
      errorMessageIndex++
    ) {
      if (errormessages[errorMessageIndex].length > maxSize) {
        maxSize = errormessages[errorMessageIndex].length;
      }
    }
    //show headline
    headlineChars = Array(startErrorlineChars.length + maxSize + 1).join(
      headlineChar
    );
    this.addString(headlineChars);
    //show all error messages
    for (
      var errorMessageIndex = 0;
      errorMessageIndex < errormessages.length;
      errorMessageIndex++
    ) {
      this.addString(startErrorlineChars + errormessages[errorMessageIndex]);
    }
    //show user input
    this.addString(startErrorlineChars + input.toUpperCase());
    //show headline
    this.addString(headlineChars);
  }
  public deleteAll(emitEvent = false) {
    this.commands = [""];
    this.space.next(this.commands);
    if (emitEvent) {
      this.ctEmitter.emit();
    }
  }
  public getCommand(keycode: number) {
    // If input line is disabled, ignore keystrokes
    if (this.inputLine.getReadOnly()) {
      return;
    }
    if (keycode === 38) {
      // Case Arrow Up
      this.currentCommandIndex--;
      if (this.getCommandLineText() === "") {
        /*
          TODO: in this case, wouldn't it be better to just stay on the
          last command instead of looping around?
        */
        this.currentCommandIndex = this.historyCommandsOnly.length - 1;
      }
      if (this.currentCommandIndex >= 1) {
        this.setCommandLineText(
          this.historyCommandsOnly[this.currentCommandIndex]
        );
      } else {
        this.setCommandLineText("");
      }
    } else {
      // Case Arrow Down
      if (
        this.currentCommandIndex < this.historyCommandsOnly.length - 1 &&
        this.currentCommandIndex >= -1
      ) {
        this.currentCommandIndex++;
        this.setCommandLineText(
          this.historyCommandsOnly[this.currentCommandIndex]
        );
      } else {
        this.setCommandLineText("");
      }
    }
  }
  removeAllCommandFromHistory() {
    this.commands = [{}];
    this.historyCommandsOnly = [""];
    this.currentCommandIndex = -1;
  }
  getData() {
    return this.commands;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/commands.service.ts